export default __webpack_public_path__ + "static/media/WF.1a1db47b.svg";